<template>
	<transition name="search">
		<div class="search">
			<div class="box">
				<div class="input">
					<div class="icon" v-html="require('@/assets/icons/search-regular.svg')"/>
					<input v-bind="{placeholder}" v-model="input" @keyup="update(input)"/>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import {debounce} from "lodash";

export default {
	data() {
		return {
			placeholder: "Søg",
			input: this.$route.query.search
		}
	},
	methods: {
		update: debounce(function(input) {
			this.$emit("update", {query: {search: input || undefined}});
		}, 500)
	}
};
</script>

<style lang="scss" scoped>
.search {
	position: absolute;
	top: 100%;
	left: 0;
	right: 0;

	$t: 0.2s;

	&-enter-active, &-leave-active {
		transition: background-color $t; // enable child transitions
	}

	@at-root {
		.box {
			background-color: $white1;
			padding: 16px 24px;
			border-bottom: 1px solid #E1E5E7;

			.search-enter-active &, .search-leave-active & {
				transition: cubic(transform, $t);
			}

			.search-enter &, .search-leave-to & {
				transform: translateY(-100%);
			}

			.input {
				height: 38px;
				width: 100%;
				border: 1px solid #E1E5E7;
				border-radius: 4px;
				box-shadow: 0 2px 4px 0 #F4F6F8;
				display: flex;
				align-items: center;
				padding: 0 14px;

				.icon {
					display: inline-flex;
					margin-right: 9px;

					/deep/ svg {
						$s: 14px;
						width: $s;
						height: $s;
						path {
							fill: #B3B9BF;
						}
					}
				}

				input {
					font-size: 14px;
					width: 100%;
					outline: 0;
					apperance: none;
					border: 0px;
					height: 100%;

					@include placeholder {
						color: #B3B9BF;
					}
				}
			}
		}
	}
}
</style>
